/* React */
import React from 'react';

/* Styles */
import { Tile } from '../../style';

/* Hooks */
import { useWordle } from '../../../WordleContext';

/* Interfaces */
import { IBoard } from '../../interfaces/WordleInterface';

interface Props {
  row: number
  index: number
  boardData: IBoard | null
}

export const GameBoard: React.FC<Props> = ({ row, index, boardData }: Props) => {

  /* Context */
  const {
    defineRowIndex,
    borderColor
  } = useWordle();

  return (
    <>
      <Tile hasAnimation={defineRowIndex(index)} transitionDelay={'0s'} animationDelay={'0s'} themeColor={borderColor}>
        <div className={`letter ${boardData && boardData.boardRowStatus[row] ? boardData.boardRowStatus[row][0] : ""}`}>
          <h1>
            {boardData && boardData.boardWords[row] && boardData.boardWords[row][0]}
          </h1>
        </div>
      </Tile>
      <Tile hasAnimation={defineRowIndex(index)} transitionDelay={'0.6s'} animationDelay={'0.45s'} themeColor={borderColor}>
        <div className={`letter ${boardData && boardData.boardRowStatus[row] ? boardData.boardRowStatus[row][1] : ""}`}>
          <h1>
            {boardData && boardData.boardWords[row] && boardData.boardWords[row][1]}
          </h1>
        </div>
      </Tile>
      <Tile hasAnimation={defineRowIndex(index)} transitionDelay={'1.2s'} animationDelay={'0.9s'} themeColor={borderColor}>
        <div className={`letter ${boardData && boardData.boardRowStatus[row] ? boardData.boardRowStatus[row][2] : ""}`}>
          <h1>
            {boardData && boardData.boardWords[row] && boardData.boardWords[row][2]}
          </h1>
        </div>
      </Tile>
      <Tile hasAnimation={defineRowIndex(index)} transitionDelay={'1.6s'} animationDelay={'1.35s'} themeColor={borderColor}>
        <div className={`letter ${boardData && boardData.boardRowStatus[row] ? boardData.boardRowStatus[row][3] : ""}`}>
          <h1>
            {boardData && boardData.boardWords[row] && boardData.boardWords[row][3]}
          </h1>
        </div>
      </Tile>
      <Tile hasAnimation={defineRowIndex(index)} transitionDelay={'2s'} animationDelay={'1.8s'} themeColor={borderColor}>
        <div className={`letter ${boardData && boardData.boardRowStatus[row] ? boardData.boardRowStatus[row][4] : ""}`}>
          <h1>
            {boardData && boardData.boardWords[row] && boardData.boardWords[row][4]}
          </h1>
        </div>
      </Tile>
    </>
  );
};
